/**
 * Session-scoped dismiss for post-purchase favorite prompt (Stage 6).
 * Survives in-tab navigation during checkout complete; cleared when tab closes.
 */

export const POST_PURCHASE_FAVORITE_DISMISS_STORAGE_PREFIX =
  'customer:postPurchaseFavoriteDismiss:';

function buildDismissStorageKey(tenantCode: string, salesPointId: number): string {
  return `${POST_PURCHASE_FAVORITE_DISMISS_STORAGE_PREFIX}${tenantCode.trim().toLowerCase()}:${salesPointId}`;
}

export function dismissPostPurchaseFavoritePrompt(
  tenantCode: string,
  salesPointId: number,
): void {
  if (typeof window === 'undefined') {
    return;
  }
  if (tenantCode.trim().length === 0 || !(salesPointId > 0)) {
    return;
  }
  try {
    window.sessionStorage.setItem(buildDismissStorageKey(tenantCode, salesPointId), '1');
  } catch {
    /* quota / private mode — best-effort */
  }
}

export function isPostPurchaseFavoritePromptDismissed(
  tenantCode: string,
  salesPointId: number,
): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  if (tenantCode.trim().length === 0 || !(salesPointId > 0)) {
    return false;
  }
  try {
    return (
      window.sessionStorage.getItem(buildDismissStorageKey(tenantCode, salesPointId)) === '1'
    );
  } catch {
    return false;
  }
}
